var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPictoApport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-picto-apport"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ilus-apport"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23085 15.5042C6.11554 20.2372 8.68954 19.7414 8.68954 21.9705C8.68954 24.1995 12.9593 23.5609 14.0455 23.5634C15.2735 23.5634 18.3471 23.9765 18.5883 22.3864C18.8294 20.7963 20.0831 20.8675 20.0831 18.7117C20.0831 17.5205 19.7506 15.7931 19.1776 14.7307C18.1224 12.7742 16.2375 11.3035 14.0455 11.3035C11.4046 11.3035 9.06225 12.9972 8.23085 15.5042Z",
    fill: "#FCBF1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 5,
    width: 4,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5117 5.51587H15.9197V9.08987H12.5117V5.51587Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1938 5.51465C12.818 5.51465 12.5117 5.87501 12.5117 6.19676C12.5117 6.92777 13.2041 8.33833 13.6005 9.08993H14.8309C15.2273 8.33833 15.9197 6.92777 15.9197 6.19676C15.9197 5.87501 15.6134 5.51465 15.2376 5.51465H13.1938Z",
    fill: "#FCBF1E"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4702 6.19556C10.0944 6.19556 9.78809 6.55592 9.78809 6.87767C9.78809 7.55978 10.9721 8.50958 11.7804 9.09131H12.9361C12.8434 8.90855 12.7714 8.77985 12.6555 8.5379C12.3029 7.78886 11.9168 6.97033 11.9168 6.19556H10.4702Z",
    fill: "#FECA40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5118 6.19556C16.5118 6.97033 16.1283 7.78886 15.7757 8.5379C15.6624 8.77985 15.5904 8.90855 15.4951 9.09131H16.6508C17.4565 8.50958 18.6431 7.55978 18.6431 6.87767C18.6431 6.55592 18.3368 6.19556 17.961 6.19556H16.5118Z",
    fill: "#F9C94B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1717 9.60056C11.7959 9.60056 11.4922 9.90429 11.4922 10.2827C11.4922 10.6585 11.7959 10.9622 12.1717 10.9622H12.2284C12.8075 10.8 13.4124 10.7074 14.043 10.7074C14.6711 10.7074 15.2811 10.8 15.8577 10.9622H15.9195C16.2953 10.9622 16.599 10.6585 16.599 10.2827C16.599 9.90429 16.2953 9.60056 15.9195 9.60056H12.1717Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34617 7.21244C6.17113 7.23304 6.03986 7.38233 6.04501 7.55993V7.88683C6.02699 8.07473 6.16856 8.23947 6.35389 8.25491C6.54179 8.27036 6.70652 8.13136 6.72197 7.94346C6.72454 7.92544 6.72454 7.90742 6.72197 7.88683V7.55993C6.72712 7.37203 6.57783 7.21502 6.3925 7.21244C6.37705 7.21244 6.36161 7.21244 6.34617 7.21244Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34617 8.91679C6.17371 8.93738 6.04243 9.0841 6.04501 9.25913V9.59118C6.02699 9.77908 6.16856 9.94382 6.35389 9.95926C6.54179 9.9747 6.70652 9.83571 6.72197 9.64781C6.72454 9.62979 6.72454 9.61177 6.72197 9.59118V9.25913C6.72454 9.07123 6.57268 8.91679 6.38478 8.91679C6.37191 8.91679 6.35904 8.91679 6.34617 8.91679Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03495 8.23298C6.84704 8.24327 6.70033 8.40286 6.71062 8.59334C6.72092 8.78124 6.88051 8.92796 7.07098 8.91766H7.40303C7.59093 8.91766 7.7428 8.76579 7.7428 8.57532C7.7428 8.38742 7.59093 8.23298 7.40303 8.23298H7.07098H7.03495Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33084 8.23298C5.14294 8.24327 4.99622 8.40286 5.00652 8.59334C5.01682 8.78124 5.1764 8.92796 5.36688 8.91766H5.69893C5.88683 8.91766 6.03869 8.76579 6.03869 8.57532C6.03869 8.38742 5.88683 8.23298 5.69893 8.23298H5.36688H5.33084Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72473 11.3035C6.72473 11.4914 6.57287 11.6459 6.38497 11.6459C6.19449 11.6459 6.04262 11.4914 6.04262 11.3035C6.04262 11.1156 6.19449 10.9638 6.38497 10.9638C6.57287 10.9638 6.72473 11.1156 6.72473 11.3035Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74555 13.346C7.74555 13.5339 7.59111 13.6884 7.40321 13.6884C7.21531 13.6884 7.06087 13.5339 7.06087 13.346C7.06087 13.1581 7.21531 13.0062 7.40321 13.0062C7.59111 13.0062 7.74555 13.1581 7.74555 13.346Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0621 21.8633C22.8742 21.8684 22.7249 22.0228 22.7301 22.2107V22.5428C22.7146 22.7281 22.8536 22.8929 23.0389 22.9083C23.2268 22.9237 23.3941 22.7847 23.4096 22.5968C23.4122 22.5788 23.4122 22.5608 23.4096 22.5428V22.2107C23.4122 22.0228 23.2629 21.8658 23.075 21.8633H23.0621Z",
    fill: "#120136"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0274 20.1642C22.8575 20.1874 22.7288 20.3315 22.7313 20.5066V20.8386C22.7159 21.024 22.8549 21.1887 23.0402 21.2041C23.2281 21.2196 23.3954 21.0806 23.4083 20.8927C23.4109 20.8747 23.4109 20.8566 23.4083 20.8386V20.5066C23.4109 20.3187 23.2616 20.1642 23.0737 20.1617C23.0582 20.1617 23.0428 20.1617 23.0274 20.1642Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0161 21.1849C21.8307 21.2081 21.6969 21.3754 21.7175 21.5607C21.7381 21.7332 21.8796 21.8619 22.0521 21.8645H22.3841C22.5695 21.8799 22.7342 21.7409 22.7496 21.553C22.7677 21.3651 22.6261 21.2004 22.4408 21.1849C22.4202 21.1823 22.3996 21.1823 22.3841 21.1849H22.0521C22.0392 21.1823 22.0289 21.1823 22.0161 21.1849Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7211 21.1849C23.5358 21.2081 23.402 21.3754 23.4226 21.5607C23.4431 21.7332 23.5847 21.8619 23.7572 21.8645H24.0892C24.2745 21.8799 24.4393 21.7409 24.4547 21.553C24.4727 21.3651 24.3312 21.2004 24.1458 21.1849C24.1253 21.1823 24.1047 21.1823 24.0892 21.1849H23.7572C23.7443 21.1823 23.734 21.1823 23.7211 21.1849Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3659 19.1362C21.3659 18.9483 21.5203 18.7938 21.7082 18.7938C21.8935 18.7938 22.048 18.9483 22.048 19.1362C22.048 19.3215 21.8935 19.476 21.7082 19.476C21.5203 19.476 21.3659 19.3241 21.3659 19.1362Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8557 12.3253H21.8751C21.9729 12.3253 22.0475 12.3999 22.0475 12.4952V13.517C22.0475 13.6123 21.9729 13.6869 21.8751 13.6869H20.8557C20.7631 13.6869 20.6859 13.6123 20.6859 13.517V12.4952C20.6859 12.3999 20.7631 12.3253 20.8557 12.3253ZM21.3654 10.9636C20.2328 10.9636 19.3242 11.8722 19.3242 13.0048C19.3242 13.1155 19.3397 13.221 19.3577 13.3291C19.6717 13.7332 19.942 14.176 20.1582 14.6496C20.4954 14.8993 20.9098 15.0511 21.3654 15.0511C22.498 15.0511 23.4117 14.1374 23.4117 13.0048C23.4117 11.8722 22.498 10.9636 21.3654 10.9636Z",
    fill: "#E9A900"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPictoApport);
export default __webpack_public_path__ + "static/media/ic-picto-apport.84e9945a.svg";
export { ForwardRef as ReactComponent };